export default {"src":"/_next/static/media/potatognocchi.c91e28f3.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};